<template>
  <el-container style="width: 96%; margin: 20px auto;">
    <!-- <el-header>
      <el-button round @click="createClick">{{generateCustomizeString('add')}}</el-button>
      <el-button round>{{generateCustomizeString('delete')}}</el-button>
      <el-button round>{{generateCustomizeString('refresh')}}</el-button>
    </el-header> -->
    <el-table ref="multipleTable" :data="tableData3" height="600" tooltip-effect="dark" >
      <!-- <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="Id" :label="generateCustomizeString('ID')">
      </el-table-column> -->
      <el-table-column :label="generateCustomizeString('shopLogo')">
        <template slot-scope="scope">
          <img :src="scope.row.logoUrl" style="width:auto;height:100px;" />
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="generateCustomizeString('shopName')">
      </el-table-column>
      <el-table-column prop="type" :label="generateCustomizeString('shopType')">
      </el-table-column>
      <el-table-column prop="shopUrl" :label="generateCustomizeString('shopUrls')">
        <!-- <template slot-scope="scope">
            <a href="scope.row.shopUrl">点击店铺地址</a>
          </template> -->
      </el-table-column>
      <el-table-column prop="activity" :label="generateCustomizeString('shopActivity')">
        <template slot-scope="scope">
          <label v-if="scope.row.activity === true">{{generateCustomizeString('shopReady')}}</label>
          <label v-else>{{generateCustomizeString('shopWaitForReview')}}</label>
        </template>
      </el-table-column>
      <el-table-column prop="createAt" :label="generateCustomizeString('createAt')" show-overflow-tooltip>
      </el-table-column>
      <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="180">
        <template slot-scope="scope">
          <el-button @click="editClick(scope.row)" type="text" size="small">{{generateCustomizeString('edit')}}</el-button>
          <el-button type="text" size="small">{{generateCustomizeString('delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination background layout="prev, pager, next" :total="1000">
      </el-pagination>
    </el-footer> -->
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'

export default {
  name: 'Shop',
  data() {
    return {
      tableData3: [
        {
          // Id: 10001,
          logoUrl: 'http://brandmark.io/logo-rank/random/apple.png',
          name: '新西兰百分百',
          type: '企业',
          shopUrl: 'https://jd.com',
          activity: true,
          createAt: '2016-05-03'
        },
        {
          // Id: 10002,
          logoUrl:
            'http://cdn1-blog.designhill.com/wp-content/uploads/2015/01/Adidas_Logo.png',
          name: '千分之一新西兰',
          type: '个人',
          shopUrl: 'https://jd.com',
          activity: false,
          createAt: '2016-05-03'
        }
      ],
      multipleSelection: []
    }
  },
  methods: {
    generateCustomizeString,
    //   toggleSelection(rows) {
    //     if (rows) {
    //       rows.forEach(row => {
    //         this.$refs.multipleTable.toggleRowSelection(row)
    //       })
    //     } else {
    //       this.$refs.multipleTable.clearSelection()
    //     }
    //   },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    editClick(row) {
      this.$router.push({ name: 'EditShop', params: { shopId: row.Id }})
    },
    createClick() {
      this.$router.push({ name: 'CreateShop' })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #efefef;
  color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
